import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { ref, onBeforeMount } from 'vue';
import Icon from '@/components/renewal/common/icon.vue';
import PanelHeader from '@/components/renewal/common/panel-header.vue';
import FormatSection from '@/components/renewal/format/format-section.vue';
import { useRepositories } from '@/plugins/repositories';
import { useTelemetry } from '@/plugins/telemetry';
export default /*#__PURE__*/_defineComponent({
  __name: 'format-panel',
  setup: function setup(__props) {
    var $repositories = useRepositories();
    var telemetry = useTelemetry();
    var route = useRoute();
    var categoriesLoading = ref(true);
    var categories = ref([]);
    var categoriesForLoading = computed(function () {
      return Array.from({
        length: 5
      }, function () {
        return {
          name: ''
        };
      });
    });
    var totalCountLoading = ref(true);
    var totalCount = ref(null);
    var categoriesCountLoading = ref(true);
    var categoriesCount = ref({
      counts: []
    });
    var onClick = function onClick(category) {
      if (categoriesLoading.value) {
        return;
      }
      telemetry.sendClickTelemetry({
        button: 'format-categories-section__item',
        params: {
          format: {
            category: category
          }
        }
      }, route);
    };
    var fetchCategories = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return $repositories.format.getCategories();
            case 3:
              categories.value = _context.sent;
              _context.next = 9;
              break;
            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](0);
              console.error(_context.t0);
            case 9:
              _context.prev = 9;
              categoriesLoading.value = false;
              return _context.finish(9);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 6, 9, 12]]);
      }));
      return function fetchCategories() {
        return _ref.apply(this, arguments);
      };
    }();
    var fetchTotalCount = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return $repositories.format.getFormatFileCount();
            case 3:
              totalCount.value = _context2.sent;
              _context2.next = 9;
              break;
            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2["catch"](0);
              console.error(_context2.t0);
            case 9:
              _context2.prev = 9;
              totalCountLoading.value = false;
              return _context2.finish(9);
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 6, 9, 12]]);
      }));
      return function fetchTotalCount() {
        return _ref2.apply(this, arguments);
      };
    }();
    var fetchCategoriesCount = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return $repositories.format.getFormatCategoriesCount();
            case 3:
              categoriesCount.value = _context3.sent;
              _context3.next = 9;
              break;
            case 6:
              _context3.prev = 6;
              _context3.t0 = _context3["catch"](0);
              console.error(_context3.t0);
            case 9:
              _context3.prev = 9;
              categoriesCountLoading.value = false;
              return _context3.finish(9);
            case 12:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0, 6, 9, 12]]);
      }));
      return function fetchCategoriesCount() {
        return _ref3.apply(this, arguments);
      };
    }();
    onBeforeMount(function () {
      fetchCategories();
      fetchTotalCount();
      fetchCategoriesCount();
    });
    return {
      __sfc: true,
      $repositories: $repositories,
      telemetry: telemetry,
      route: route,
      categoriesLoading: categoriesLoading,
      categories: categories,
      categoriesForLoading: categoriesForLoading,
      totalCountLoading: totalCountLoading,
      totalCount: totalCount,
      categoriesCountLoading: categoriesCountLoading,
      categoriesCount: categoriesCount,
      onClick: onClick,
      fetchCategories: fetchCategories,
      fetchTotalCount: fetchTotalCount,
      fetchCategoriesCount: fetchCategoriesCount,
      Icon: Icon,
      PanelHeader: PanelHeader,
      FormatSection: FormatSection
    };
  }
});